import React, { Component, useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';

import htmlToDraft from 'html-to-draftjs';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { convertFromRaw, EditorState } from 'draft-js';

const tool_bar_option = {
	options: ['inline', 'emoji', 'history'],
	// options: ['inline', 'blockType', 'list', 'emoji', 'history'],
	blockType: {
		inDropdown: true,
		options: ['Normal', 'H1', 'H2'],
		className: undefined,
		component: undefined,
		dropdownClassName: undefined,
	},
	inline: {
		inDropdown: false,
		className: undefined,
		component: undefined,
		dropdownClassName: undefined,
		options: ['bold', 'italic'],
	},
};

const styleMap = {
	1: {
		textDecoration: 'bold',
	},
	2: {
		textDecoration: 'italic',
	},
};

// const TextEditor = ({
// 	handleEditorChange,
// 	automationPostForm,
// 	textEdtState,
// }) => {

// 	// const [editorState, setEditorState] = useState(EditorState.createEmpty());

// 	// useEffect(() => {
// 	// 	console.log(automationPostForm.contentHtml);
// 	// 	if (automationPostForm.contentHtml)
// 	// 		setEditorState(
// 	// 			EditorState.createWithContent(
// 	// 				ContentState.createFromBlockArray(
// 	// 					convertFromHTML(automationPostForm.contentHtml)

// 	// 					// convertFromRaw(JSON.parse(automationPostForm.content))
// 	// 				)
// 	// 			)
// 	// 		);
// 	// }, [automationPostForm.contentHtml]);
// 	// console.log(automationPostForm.content)

// 	const onEditorStateChange = (editorState) => {
// 		console.log('editorStateChange :: ,', editorState);
// 	};

// 	return (
// 		<Editor
// 			wrapperClassName='demo-wrapper'
// 			editorClassName='demo-editor'
// 			onContentStateChange={handleEditorChange}
// 			toolbar={tool_bar_option}
// 			customStyleMap={styleMap}
// 			editorState={textEdtState.editorState}
// 			onChange={onEditorStateChange}
// 			// initialContentState={textEdtState}
// 			// defaultContentState={automationPostForm.content}
// 			//EditorState.createWithContent(contentState
// 			// value={contentState}
// 			// editorState={contentState}
// 			// onEditorStateChange={onEditorStateChange}
// 		/>
// 	);
// };
const content = {
	entityMap: {},
	blocks: [
		{
			key: '637gr',
			text: 'Initialized from content state.',
			type: 'unstyled',
			depth: 0,
			inlineStyleRanges: [],
			entityRanges: [],
			data: {},
		},
	],
};

class TextEditor extends Component {
	constructor(props) {
		super(props);
		this.state = {
			editorState: EditorState.createEmpty(),
		};
		console.log(props);
	}

	onEditorStateChange: Function = (editorState) => {
		console.log(this.props);

		this.props.setTextEdtState({
			editorState,
		});
	};

	render() {
		return (
			<div className='editor'>
				<Editor
					editorState={this.props.textEdtState.editorState}
					onEditorStateChange={this.onEditorStateChange}
					onContentStateChange={this.props.handleEditorChange}
					toolbar={tool_bar_option}
					customStyleMap={styleMap}
					wrapperClassName='demo-wrapper'
					editorClassName='demo-editor'
				/>
			</div>
		);
	}
}

export default TextEditor;
